import React from 'react';
import { Link } from '@material-ui/core';

import { TaskJiraIssue } from '../../tasks/TaskJiraIssue.interface';

type JiraLinkProps = {
  isJiraServer?: boolean;
  issue: Pick<TaskJiraIssue, 'key'>;
  baseUrl?: string;
  target?: string;
};

const JiraLink: React.FC<JiraLinkProps> = ({
  isJiraServer,
  issue,
  baseUrl,
  target = '_blank'
}) => {
  return isJiraServer ? (
    <a href={`${baseUrl}/browse/${issue.key}`} target={target}>
      {issue.key}
    </a>
  ) : (
    <Link
      style={{ cursor: 'pointer' }}
      onClick={() => {
        console.log('issue:', issue);
        if (typeof AP?.navigator?.go === 'function') {
          AP.navigator.go('issue', { issueKey: issue.key });
        }
      }}
    >
      {issue.key}
    </Link>
  );
};

export default JiraLink;
